import celebrationUrl1 from '../../../assets/audio/festejoRiza.mp3';
import celebrationUrl2 from '../../../assets/audio/festejoRiza2.mp3';
import celebrationUrl3 from '../../../assets/audio/festejoRiza3.mp3';

// Suena cada vez que el diablito cambia de festejo en una racha, alternando
// entre los tres efectos en el mismo orden que las animaciones
// (sonrisa -> victoria -> salto).
// Mismo patrón que entryRevealAudio: HTMLMediaElement + ganancia Web Audio
// para respetar el nivel sin perder el control nativo del MP3.
export const CELEBRATION_GAIN = 0.4;

const celebrationUrls = [celebrationUrl1, celebrationUrl2, celebrationUrl3];

let sharedAudios = null;
let audioContext = null;
const amplifierNodes = new Map();
let nextSoundIndex = 0;

function getCelebrationAudios() {
  if (!sharedAudios) {
    sharedAudios = celebrationUrls.map((url) => {
      const audio = new Audio(url);
      audio.preload = 'auto';
      audio.volume = 1;
      return audio;
    });
  }
  return sharedAudios;
}

function connectAmplifier(audio) {
  const Context = window.AudioContext || window.webkitAudioContext;
  if (!Context) return false;

  try {
    if (!audioContext) audioContext = new Context({ latencyHint: 'interactive' });
    // Cada elemento necesita su propio MediaElementSource (solo se crea una vez).
    if (!amplifierNodes.has(audio)) {
      const mediaSource = audioContext.createMediaElementSource(audio);
      const gainNode = audioContext.createGain();
      gainNode.gain.value = CELEBRATION_GAIN;
      mediaSource.connect(gainNode);
      gainNode.connect(audioContext.destination);
      amplifierNodes.set(audio, gainNode);
    }
    if (audioContext.state !== 'running') audioContext.resume().catch(() => {});
    return true;
  } catch {
    return false;
  }
}

export function preloadCelebrationAudio() {
  try {
    getCelebrationAudios().forEach((audio) => audio.load());
  } catch {
    // La reproducción volverá a intentarse cuando comience el festejo.
  }
}

export function playCelebrationAudio() {
  try {
    const audios = getCelebrationAudios();
    const audio = audios[nextSoundIndex % audios.length];
    nextSoundIndex = (nextSoundIndex + 1) % audios.length;
    audio.pause();
    audio.currentTime = 0;
    audio.volume = 1;
    connectAmplifier(audio);
    const attempt = audio.play();
    if (attempt && typeof attempt.catch === 'function') attempt.catch(() => {});
    return attempt;
  } catch {
    return undefined;
  }
}
